<template>
    <Navbar></Navbar>
    <div class="product-detail-page">
        <div class="detail-banner">
            <div class="img-box detail-banner-img">
                <img src="/assets/product/electronics/IN8/IN8.jpg" alt="200-1-01">
            </div>
            <div class="detail-banner-r">
                
                <div class="detail-banner-t2">IN8.0 Cockpit Domain Controller</div>
                <div class="detail-banner-desc">
                    It is integrated the TBOX(Telematic Box) and Multi-Screen interaction、3D Vehicle model linkage、Intelligent driving interaction and ecological APP;<br />
                    There are Type-A and Type-C ports, which are supporting USB audio, video and switch game projection;<br />
                    Linux(Cluster) + Linux(TBOX) + Android(IVI) are running on single chip, which has integrated multiple displays, multiple cameras, Ecall(Emergency Call), multi-form desktop, 3D Vehicle model interaction, online navigation, voice recognition and etc.
                </div>
            </div>
        </div>

        <div class="detail-center">
            <div class="detail-center-l">
                <div class="detail-text-box">
                    <div class="detail-title">Product Introduction</div>

                    <div class="detail-desc">
                        <div>
                            MTK8676 all-new digital cockpit platform.<br />
                        </div>
                        <div>
                            Multiple operating systems (Linux/Linux/Android) on single chip.<br />
                        </div>
                        <div>
                            Up to 4 displays, 11 cameras, 4 analog mic, 12 digital mic.<br />
                        </div>
                        <div>
                            4*100M/1*1000M Ethernet, 3*CAN(FD), 1*LIN.<br />
                        </div>
                        <div>
                            USB 2.0/3.0, WiFi 6E, BT 5.3<br />
                        </div>
                        <div>
                            HiCar/ICCOA/Carplay/Android Auto
                        </div>
                    </div>
                </div>

                <div class="one-titile">
                    Core Configuration
                </div>
                <div class="spec-row">
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/IN8/IN8-1.jpg" alt="200-1-02">
                    </div>
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                Parameters
                            </div>
                            <div class="spec-col">
                                <div class="spec-item">
                                    <div class="v">4nm</div>
                                    <div class="k">Process</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">170K DMIPS</div>
                                    <div class="k">CPU</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">1800 GFLOPS</div>
                                    <div class="k">GPU</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">20 TOPS</div>
                                    <div class="k">NPU</div>
                                </div>
                                
                                <div class="spec-item">
                                    <div class="v">Up to 4</div>
                                    <div class="k">Display</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">16/24G + 128/256G</div>
                                    <div class="k">Memory</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">1*1000 Base-T1+ 4*100 Base-T1</div>
                                    <div class="k">Ethernet</div>
                                </div>
                                
                                <div class="spec-item spec-item-last">
                                    <div class="v">5G NR: SA/NSA、4G:TDD/FDD LTE</div>
                                    <div class="k">Network</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">GPS/Beidou/Glonass/Galileo</div>
                                    <div class="k">GNSS</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">Main BT: BT5.3、Vice BT: BT5.2 & BLE、WIFI6 & WIFI6E</div>
                                    <div class="k">BT-WIFI</div>
                                </div>
                                
                                
                            </div>
                        </div>
                    </div>
                </div>

                <!-- <div class="spec-row">
                    
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                Parameters
                            </div>
                            <div class="spec-col">
                            </div>
                        </div>
                    </div>
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/IN8/IN8-1.jpg" alt="200-1-02">
                    </div>
                </div> -->

            </div>
        </div>
    </div>
    <Footer></Footer>
</template>

<script setup>
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
</script>

<script>
export const pageConfig = {
  title: 'IN8.0 Cockpit Domain Controller - FINEST Website',
  keywords: 'FINEST,Engine,Transmission,Electronics',
  description: 'FINEST Automotive Technology Group Co., Ltd.An auto parts enterprise with core technologies of power system from traditional power to hybrid power and then to pure electric power (including inverters) and automotive intelligent integrated system.FINEST has a complete software and hardware industry chain Provide customers with efficient, energy-saving and environmentally friendly automotive power system and Intelligent driving solutions.',
  outputPath: 'en/electronics/IN8.html'
};

import { createApp } from 'vue';
import App from './IN8.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/transmission-200.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./IN8.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss" scoped></style>
